import { BillingPeriod } from "@redotech/redo-model/billing/service-invoice";
import * as z from "zod/v4";

export type ReturnsInvoiceStatus = z.infer<typeof returnsInvoiceStatus>;
export const returnsInvoiceStatus = z.object({
  period: z.enum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentReturnsInvoice = {
  name: "getCurrentReturnsInvoice" as const,
  input: z.null(),
  output: returnsInvoiceStatus.nullable(),
};
